import { type PreferredCommunicationMethod, type User } from '~shared/types';

export type CommunicationPreferencesFormFields = {
  preferred_communication: PreferredCommunicationMethod | undefined;
  phi_auth_data: {
    sms_authorized: boolean;
    email_authorized: boolean;
    push_authorized: boolean;
  };
  secondary_communication_preference: PreferredCommunicationMethod | undefined;
};

export type UserPhiAuthValues = {
  sms_authorized?: boolean;
  push_authorized?: boolean;
  email_authorized?: boolean;
  user_prompted?: boolean;
};

export type ValidationErrors = {
  preferred_communication?: string;
  secondary_communication_preference?: string;
};

type Option = {
  value: string;
  label: string;
};

export const CALL = 'call';
const callOption: Option = {
  value: CALL,
  label: 'Call',
};

export const SECURE_MESSAGE = 'secure_message';
const secureOption: Option = {
  value: SECURE_MESSAGE,
  label: 'Secure in-app messages',
};

export const TEXT = 'text';
const textOption: Option = {
  value: TEXT,
  label: 'Text/SMS',
};

export const EMAIL = 'email';
const emailOption: Option = {
  value: EMAIL,
  label: 'Email',
};

export const PREFERRED_COMMUNICATION_OPTIONS: Option[] = [secureOption, textOption, emailOption, callOption];
export const SECONDARY_COMMUNICATION_PREFERENCE_OPTIONS: Option[] = [textOption, emailOption];

export const getSecondaryContactLabel = (
  primaryOption: User['preferred_communication'],
  phi: User['phi_auth_info'],
  secondaryCommunicationPreference: User['secondary_communication_preference'],
): string => {
  switch (primaryOption) {
    case SECURE_MESSAGE:
      return secondaryCommunicationPreference ? `(Notification via ${secondaryCommunicationPreference})` : '';

    case TEXT:
      return `(${phi?.sms_authorized ? 'Include' : 'Don’t include'} health information)`;

    case EMAIL:
      return `(${phi?.email_authorized ? 'Include' : 'Don’t include'} health information)`;

    default:
      return '';
  }
};

export const validate = (formFields: CommunicationPreferencesFormFields): ValidationErrors => {
  const { preferred_communication, secondary_communication_preference } = formFields;

  const validationErrors: ValidationErrors = {};

  if (!preferred_communication) {
    validationErrors.preferred_communication = 'Please select a communication preference';
  }

  // if secure, ensure secondary comms preference
  if (preferred_communication === SECURE_MESSAGE && !secondary_communication_preference) {
    validationErrors.secondary_communication_preference = 'Please select a notification type';
  }

  return validationErrors;
};
